<nav class="tk-stela-breadcrumbs flex min-h-5 flex-wrap items-center gap-2 text-[12.5px] text-(--stela-text-secondary)">
  @for (item of items(); track item.label + $index) {
    @if ($last) {
      <span class="tk-stela-breadcrumb-current inline-flex items-center gap-1">
        @if (item.icon) {
          <i [class]="item.icon"></i>
        }
        <span>{{ item.label }}</span>
      </span>
    } @else if (item.route) {
      <a [routerLink]="item.route" [queryParams]="item.queryParams ?? null" class="tk-stela-breadcrumb-link inline-flex items-center gap-1">
        @if (item.icon) {
          <i [class]="item.icon"></i>
        }
        <span>{{ item.label }}</span>
      </a>
    } @else {
      <!-- Item intermedio sin route (p.ej. una sección como "BBDD" que no
           es una página navegable): mismo estilo que un enlace normal, sin
           negrita ni color "current" — solo el último item la lleva. -->
      <span class="tk-stela-breadcrumb-link inline-flex items-center gap-1">
        @if (item.icon) {
          <i [class]="item.icon"></i>
        }
        <span>{{ item.label }}</span>
      </span>
    }

    @if (!$last) {
      <i class="pi pi-angle-right text-[9px] text-(--stela-fg-4)" aria-hidden="true"></i>
    }
  }
</nav>
